export default __webpack_public_path__ + "static/media/Group_of_pregnant_women.b3e99e09.jpg";